<script>
	import BarChartComparison from '$lib/Components/BarChartComparison/BarChartComparison.svelte';

	const chartData = {
		labelLeft: 'AVERAGE COST',
		labelBottom: 'ENERGY SAVINGS',
		bar: ['0%', '5%', '10%', '15%', '20%', '25%', '30%'],
		content: [
			{
				title: 'INDOW INSERT: $372',
				color: 'blue',
				percent: 65,
			},
			{
				title: 'SINGLE-PANE: $450',
				color: 'grey',
				percent: 49,
			},
			{
				title: 'DOUBLE-PANE: $539',
				color: 'grey-medium',
				percent: 60,
			},
			{
				title: 'TRIPLE-PANE: $766',
				color: 'grey-dark',
				percent: 92,
			},
		],
	};
</script>

<BarChartComparison {...chartData} />
